// extracted by mini-css-extract-plugin
export default {"SwitchRoot":"Toggle_SwitchRoot__DlTwo","SwitchThumb":"Toggle_SwitchThumb__8tCua"};